<template>
  <TopGradientBlockLayout>
    <div class="grid-daily-stats">
      <div class="grid-daily-stats__item">
        <div class="label">{{ $t('today') }}</div>
        <div class="w-full text-text text-xl mb-2">
          {{ displayCurrencyValue(dailyChange, portfolioCurrency, true, displayDailyChangeAsInt) }}
        </div>
        <div class="text-md relative"
             :class="dailyChangePercent > 0 ? 'text-green':'text-red'">
          {{ dailyChangePercent || '–' }} %
          <IconArrow class="absolute -right-4 inset-y-0 m-auto"
                     :direction="dailyChangePercent > 0 ? 'up':'down'"/>
        </div>
      </div>
      <div class="grid-daily-stats__item">
        <div class="label">{{ currentMonth }}</div>
        <div class="w-full text-text text-xl mb-2">
          {{ displayCurrencyValue(monthChange, portfolioCurrency, true, displayMonthChangeAsInt) }}
        </div>
        <div class="text-md relative"
             :class="monthChangePercent > 0 ? 'text-green':'text-red'">
          {{ monthChangePercent || '–' }} %
          <IconArrow class="absolute -right-4 inset-y-0 m-auto"
                     :direction="monthChangePercent > 0 ? 'up':'down'"/>
        </div>
      </div>
      <div class="grid-daily-stats__item">
        <div class="label">{{ $t('yearStart') }}</div>
        <div class="w-full text-text text-xl mb-2">
          {{ displayCurrencyValue(yearChange, portfolioCurrency, true, displayYearChangeAsInt) }}
        </div>
        <div class="text-md relative"
             :class="yearChangePercent > 0 ? 'text-green':'text-red'">
          {{ yearChangePercent || '–' }} %
          <IconArrow class="absolute -right-4 inset-y-0 m-auto"
                     :direction="yearChangePercent > 0 ? 'up':'down'"/>
        </div>
      </div>
      <div class="grid-daily-stats__item">
        <div class="label">{{ $t('allTime') }}</div>
        <div class="w-full text-text text-xl mb-2">
          {{ displayCurrencyValue(profitAbsolute, portfolioCurrency, true, displayProfitAbsoluteAsInt) }}
        </div>
        <div class="text-md relative"
             :class="profitPercent > 0 ? 'text-green':'text-red'">
          {{ profitPercent || '–' }} %
          <IconArrow class="absolute -right-4 inset-y-0 m-auto"
                     :direction="profitPercent > 0 ? 'up':'down'"/>
        </div>
      </div>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import IconArrow from "@/components/icons/IconArrow";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ProfitDaily",
  components: {IconArrow, TopGradientBlockLayout},
  props: [
    'dailyChange', 'dailyChangePercent',
    'monthChange', 'monthChangePercent',
    'yearChange', 'yearChangePercent',
    'profitAbsolute', 'profitPercent'
  ],
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    currentMonth() {
      return this.$moment().locale(this.$i18n.locale).format('MMMM')
    },
    displayDailyChangeAsInt() {
      return this.dailyChange >= 1000000
    },
    displayMonthChangeAsInt() {
      return this.monthChange >= 1000000
    },
    displayYearChangeAsInt() {
      return this.yearChange >= 1000000
    },
    displayProfitAbsoluteAsInt() {
      return this.profitAbsolute >= 1000000
    },
  },
  i18n: {
    messages: {
      en: {
        today: 'Today',
        yearStart: 'Start of year',
        allTime: 'All time'
      },
      ru: {
        today: 'Сегодня',
        yearStart: 'Начало года',
        allTime: 'Все время'
      }
    }
  }
}
</script>
<style scoped lang="scss">
.grid-daily-stats {
  margin: 0 -2rem;
  display: grid;
  grid-template-columns: repeat(4, 175px);
  justify-content: space-between;
  @media(min-width: 1230px) {
    margin: 0 -3rem;
    grid-template-columns: 183px 200px 200px 183px;
  }

  &__item {
    @apply font-bold flex flex-wrap justify-center text-center relative;

    .label {
      @apply rounded bg-border text-text-ternary text-2xs mb-6 mt-0-5 font-normal;
      padding: .3rem .6rem;

      &:first-letter {
        text-transform: uppercase;
      }
    }

    &:not(:first-of-type):before {
      content: '';
      @apply absolute bg-line w-px left-0;
      top: 9%;
      height: 82%;
    }
  }
}
</style>